/* eslint-disable max-lines */

export const config = {
    name: 'scenarioReference',
    selection: false,
    index: false,
    searchFields: [
        {
            name: '年份',
            value: 'dataYear',
            type: 'date',
            timeType: 'year',
            format: 'yyyy',
            valueFormat: 'yyyy',
            isFixed: true,
            clearable: false,
            span: 4
        }
    ],
    columns: [
        {
            label: '客户等级',
            prop: 'customerLevel',
            width: 160
        },
        {
            label: '客户编码',
            prop: 'customerCode',
            width: 160
        },
        {
            label: '客户名称',
            prop: 'customerName',
            width: 140
        },
        {
            label: '客户系列',
            prop: 'customerGroupName',
            width: 140
        },
        {
            label: '归类',
            prop: 'classification',
            width: 140
        },
        {
            label: '行业',
            prop: 'industryName',
            width: 140
        },
        {
            label: '细分行业',
            prop: 'subIndustryName',
            width: 140
        },
        {
            label: '片区',
            prop: 'areaName',
            width: 140
        },
        {
            label: '片区编码',
            prop: 'areaCode'
        },
        {
            label: '分公司',
            prop: 'companyName',
            width: 160
        },
        {
            label: '分公司编码',
            prop: 'companyCode'
        },
        {
            label: '客户经理开发人',
            prop: 'developerName',
            width: 160
        },
        {
            label: '客户经理开发人mip',
            prop: 'developerMip',
            width: 160
        },
        {
            label: '经营中心',
            prop: 'businessCenterName',
            width: 160
        },
        {
            label: '经营中心编码',
            prop: 'businessCenterCode',
            width: 160
        },
        {
            label: '责任制分解营销',
            prop: 'responsibilityMarketing',
            width: 160
        },
        {
            label: '责任制分解营销mip',
            prop: 'responsibilityMarketingMip',
            width: 160
        },
        {
            label: '责任制分解营销工号',
            prop: 'responsibilityMarketingNo',
            width: 160
        },
        {
            label: '年份',
            prop: 'dataYear',
            width: 160
        }
    ]
};
